import { isAuthenticated } from '@/lib/auth-guard';
import { Outlet, createRootRoute, redirect } from '@tanstack/react-router';

export const Route = createRootRoute({
  beforeLoad: async ({ location }) => {
    // `/login` is the only unguarded route.
    if (location.pathname === '/login') {
      return;
    }

    // Every other route requires a session; resolve once on boot, then gate on
    // the local token for subsequent navigations (see lib/auth-guard).
    if (!(await isAuthenticated())) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }

    // Authenticated landing on `/` → send to the dictionary.
    if (location.pathname === '/') {
      throw redirect({ to: '/words' });
    }
  },
  component: () => <Outlet />,
});
